// extracted by mini-css-extract-plugin
export default {"parameters":"styles_parameters__Ool-T","topN":"styles_topN__UvLh2"};